"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exposeBaseValidator = exports.InternalBaseValidator = exports.BaseValidator = void 0;
const validator_1 = require("../core/validator");
class BaseValidator extends validator_1.CoreValidator {
    constructor() {
        super(...arguments);
        this._parent = undefined;
    }
    setupClone(clean, clone) {
        const ret = clone;
        if (!clean)
            ret._parent = this;
        return ret;
    }
}
exports.BaseValidator = BaseValidator;
class InternalBaseValidator extends BaseValidator {
    constructor() {
        super(...arguments);
        // CoreValidator
        this._annotations = undefined;
        // BaseValidator
        this._parent = undefined;
    }
}
exports.InternalBaseValidator = InternalBaseValidator;
function exposeBaseValidator(validator) {
    return validator;
}
exports.exposeBaseValidator = exposeBaseValidator;
